module.exports = __webpack_public_path__ + "img/ícone-seta-para-cima.303b8081.svg";